import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import classNames from 'classnames';
import {
  BossModeAccoutnsTable,
  COLUMN_SIZE,
  HEADING_TRANSLATIONS,
  SORTING_VALUES,
  TABLE_COLUMNS,
} from './components/data';
import ReorderResizeTable from 'components/ReorderResizeTable';
import api from 'api';
import { User } from 'models/User';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import { BODY_CONTENT_GENERATE } from './components';
import useCallbackRef from 'hooks/useCallbackRef';
import { ModalRef } from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import RemoveBossModeModal from '../RemoveBossModeModal';
import usePageParams from 'hooks/usePageParams';
import useQueryParams from 'hooks/useQueryParams';

import './BossModeTable.styles.scss';

type BossModeTableProps = {
  className?: string;
  refetchFlag: boolean;
  limit: string;
  refetch: () => void;
};

const BossModeTable: React.FC<BossModeTableProps> = (props) => {
  const { className, refetchFlag, limit, refetch } = props;

  const [isLoading, setIsLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(0);
  const [bossModeAccounts, setBossModeAccounts] = useState<User[]>([]);

  const [selectedBossMode, setSelectedBossMode] = useState<User>();

  const [modal, modalRef] = useCallbackRef<ModalRef>(null);

  const { popServerError } = useContext(PopNotificationsContext);

  const classes = classNames('boss-mode-table', className);

  const page = usePageParams();
  const {
    params: { sort },
  } = useQueryParams();

  const onRemoveBossMode = useCallback(
    (bossMode: User) => {
      setSelectedBossMode(bossMode);
      modal?.open();
    },
    [modal],
  );

  const renderedContent = useMemo(
    () =>
      TABLE_COLUMNS.reduce(
        (acc, col) => ({
          ...acc,
          [col]: (bossMode: User) =>
            BODY_CONTENT_GENERATE[col]({
              bossMode,
              onRemoveBossMode,
            }),
        }),
        {},
      ),
    [onRemoveBossMode],
  );

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        const {
          data: { items, totalPages },
        } = await api.portfolio.admin.getBossModeAccounts({
          $limit: limit,
          $page: page,
          $sort: sort,
        });

        setTotalPages(totalPages);
        setBossModeAccounts(items);
      } catch (e) {
        popServerError(e);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [page, sort, refetchFlag, limit, popServerError]);

  return (
    <>
      <ReorderResizeTable
        className={classes}
        columns={TABLE_COLUMNS}
        customSizes={COLUMN_SIZE}
        sortingValues={SORTING_VALUES}
        isDragDisabled
        data={bossModeAccounts as any as BossModeAccoutnsTable[]}
        isDataLoading={isLoading}
        totalPages={totalPages}
        headingTranslations={HEADING_TRANSLATIONS}
        tableContentTransformations={renderedContent}
      />
      <RemoveBossModeModal
        ref={modalRef}
        bossMode={selectedBossMode}
        onRemoveBossMode={refetch}
      />
    </>
  );
};

export default BossModeTable;
